import React from "react";
import { errorToast } from "../../Common/showtoast";

function CompanyInformation({
  stateObj,
  setStateObj,
  UpdateProfile,
  setCurrentDiv,
}) {
  return (
    <div className="row">
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label">Company Name:</label>
          <input
            type="text"
            className="form-control"
            // FIX: Change 'companyname' to 'fullname' to update the name in the header
            onChange={(e) =>
              setStateObj({ ...stateObj, fullname: e.target.value })
            }
            value={stateObj.fullname || ""} // Ensure it reads from 'fullname'
          />
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label">Company Website:</label>
          <input
            onChange={(e) => {
              if (stateObj.activestatus === "True")
                setStateObj({ ...stateObj, website: e.target.value });
            }}
            value={stateObj.website || ""}
            readOnly={stateObj.activestatus !== "True"}
            placeholder={
              stateObj.activestatus !== "True"
                ? "Subscribe to Enter"
                : "e.g., https://happiedealz.com"
            }
            className="form-control"
            type="url"
          />
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label">City:</label>
          <input
            onChange={(e) => setStateObj({ ...stateObj, city: e.target.value })}
            value={stateObj.city || ""}
            className="form-control"
            type="text"
            required
          />
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label">Country:</label>
          <input
            onChange={(e) =>
              setStateObj({ ...stateObj, country: e.target.value })
            }
            value={stateObj.country || ""}
            className="form-control"
            type="text"
            required
          />
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label">Region:</label>
          <input
            onChange={(e) => {
              if (stateObj.activestatus === "True")
                setStateObj({ ...stateObj, region: e.target.value });
            }}
            readOnly={stateObj.activestatus !== "True"}
            value={stateObj.region || ""}
            placeholder={
              stateObj.activestatus !== "True" ? "Subscribe to Enter" : "Region"
            }
            className="form-control"
            type="text"
            required
          />
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label">Pincode:</label>
          <input
            onChange={(e) => {
              if (stateObj.activestatus === "True")
                setStateObj({ ...stateObj, pincode: e.target.value });
            }}
            readOnly={stateObj.activestatus !== "True"}
            value={stateObj.pincode || ""}
            placeholder={
              stateObj.activestatus !== "True"
                ? "Subscribe to Enter"
                : "Pincode"
            }
            className="form-control"
            type="text"
            required
          />
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label">Industry*:</label>
          <input
            onChange={(e) =>
              setStateObj({ ...stateObj, industry: e.target.value })
            }
            value={stateObj.industry || ""}
            className="form-control"
            type="text"
            required
          />
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label" htmlFor="companySize">Company Size:</label>
          <select
            onChange={(e) => {
              if (stateObj.activestatus === "True")
                setStateObj({ ...stateObj, companysize: e.target.value });
            }}
            readOnly={stateObj.activestatus !== "True"}
            disabled={stateObj.activestatus !== "True"}
            value={stateObj.companysize || ""}
            className="form-control"
            id="companySize"
            name="companySize"
            required
          >
            <option value=""> -- Select Comapny Size --</option>
            <option value="small">Small (1-50 employees)</option>
            <option value="medium">Medium (51-200 employees)</option>
            <option value="large">Large (201+ employees)</option>
          </select>
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label w-100">
            Mission:
            <small style={{ float: "right" }}>
              {stateObj.mission?.length || 0} / 2000
            </small>
          </label>
          <textarea
            className="form-control"
            readOnly={stateObj.activestatus !== "True"}
            style={{ minHeight: 100 }}
            onChange={(e) => {
              if (
                e.target.value.length <= 2000 &&
                stateObj.activestatus === "True"
              )
                setStateObj({ ...stateObj, mission: e.target.value });
            }}
            value={stateObj.mission || ""}
            placeholder={
              stateObj.activestatus !== "True"
                ? "Subscribe to Enter"
                : "Mission"
            }
          ></textarea>
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label w-100">
            Vision:
            <small style={{ float: "right" }}>
              {stateObj.vision?.length || 0} / 2000
            </small>
          </label>
          <textarea
            className="form-control"
            readOnly={stateObj.activestatus !== "True"}
            style={{ minHeight: 100 }}
            onChange={(e) => {
              if (
                e.target.value.length <= 2000 &&
                stateObj.activestatus === "True"
              )
                setStateObj({ ...stateObj, vision: e.target.value });
            }}
            value={stateObj.vision || ""}
            placeholder={
              stateObj.activestatus !== "True" ? "Subscribe to Enter" : "Vision"
            }
          ></textarea>
        </div>
      </div>
      <div className="form-group">
        <button
          className="btn btn-primary "
          onClick={() => {
            if (!stateObj.industry) {
              return errorToast("Please enter valid industry");
            }
            UpdateProfile();
            setCurrentDiv("companycontact");
          }}
        >
          Submit
        </button>
      </div>
    </div>
  );
}

export default CompanyInformation;